<template>
  <section>
    <header>Общая информация</header>

    <div class="subtitle">
      Наименование
    </div>
    <dl>
      <dt>Товар ЭТП</dt> <dd>{{ offer.productCategory.name }}</dd>

      <template v-if="!hideInfo">
        <dt>В ИС поставщика</dt> <dd>{{ offer.name }}</dd>
      </template>
    </dl>

    <hr>

    <dl>
      <template v-if="!hideInfo">
        <dt>Продавец</dt> <dd>{{ offer.seller?.name }}</dd>
        <dt>Юр. лицо</dt> <dd>{{ offer.sellerCompany?.name }}</dd>
      </template>

      <template v-if="offer.isMine">
        <dt>Производитель</dt> <dd>{{ offer.manufacturer?.name }}</dd>
      </template>

      <dt>Годен до</dt>  <dd>{{ offer.productExpirationDate?.format() }}</dd>
      <dt>Категория</dt> <dd>Сырье</dd>
      <dt>Доступно</dt>  <dd>{{ offer.qtyAvailable }} {{ offer.unit.name }}</dd>
      <dt>Образцы</dt>   <dd>{{ offer.isSamples ? 'Да' : 'Нет' }}</dd>
    </dl>

    <template v-if="!hideInfo">
      <hr>

      <dl>
        <dt>Описание</dt> <dd>{{ offer.description || '--' }}</dd>
      </dl>
    </template>
  </section>

  <hr>

  <section class="finance">
    <header>Финансы</header>

    <dl>
      <dt>Цена + доставка, с НДС</dt>
      <dd>
        <template v-if="$core.currentPartner.isBuyer">
          {{ offer.priceFullBuyer.format(offer.offerCurrencyCode, offer.unit) }}
        </template>
        <template v-else>
          {{ offer.priceFullSeller.format(offer.offerCurrencyCode, offer.unit) }}
        </template>
      </dd>

      <dt>Валюта предложения</dt> <dd>{{ offer.offerCurrencyCode }} ( {{$core.utils.money.getSymbolByCurrency(offer.offerCurrencyCode)}} )</dd>
      <dt>Ставка НДС</dt>         <dd>{{ offer.vatRateSeller ? `${offer.vatRateSeller}%` : '--' }}</dd>

      <template v-if="!hideInfo">
        <template v-if="offer.paymentTerm">
          <dt>{{ offer.paymentTerm.paymentTypeStringRepresentation || 'Пред/постоплата'}}</dt> <dd>{{ offer.paymentTerm.stringRepresentation || '--' }}</dd>
        </template>
        <template v-else>
          <dt>Пред/постоплата</dt> <dd>--</dd>
        </template>
      </template>
    </dl>
  </section>

  <hr>

  <section class="delivery">
    <header>Доставка</header>

    <dl>
      <dt>Интервал получения</dt>
      <dd>
        {{ offer.receiptPeriod.toString({ prefix: 'с', middle: 'по' }) }}
      </dd>

      <dt>Срок поставки</dt>            <dd>{{ offer.deliveryDays }} {{ $core.utils.regional.ru.pluralize(offer.deliveryDays, 'день', 'дня', 'дней') }}</dd>
      <dt>Способ доставки</dt>          <dd>{{ offer.deliveryType.name }}</dd>
      <dt>Упаковка</dt>                 <dd>{{ offer.package.name }}</dd>
      <dt>Фасовка</dt>                  <dd>{{ offer.packageVolume }} {{ offer.unit.name }}</dd>
      <dt>Температурный режим</dt>      <dd>{{ offer.storeTemperatureRange?.toString({ unit: '°C', negative: 'Нет' }) ?? 'Нет' }}</dd>
      <dt>Особые условия перевозки</dt> <dd>{{ offer.storeRulesText || '--' }}</dd>
    </dl>
  </section>

  <template v-if="offer.isAcceptingPreorder && !hideInfo">
    <hr>

    <section class="preorder-info">
      <header>Возможен предзаказ</header>

      <dl>
        <dt>Минимальное количество по предзаказу</dt> <dd>{{ $core.utils.number.isNumber(offer.preorderMinQty) ? offer.preorderMinQty : '--' }} {{ offer.unit.name }}</dd>
        <dt>Минимальный страховой запас</dt>          <dd>{{ $core.utils.number.isNumber(offer.preorderMonthlyReserve) ? offer.preorderMonthlyReserve : '--' }} {{ offer.unit.name }}</dd>
      </dl>
    </section>
  </template>
</template>

<script lang="ts">

import Offer from '@/domains/Offers/Offer';

export default defineComponent({
  name: 'OfferMainSection',

  props: {
    offer: {
      type:    Object as PropType<Offer>,
      default: null,
    },
  },

  computed: {
    /** Скрываем, если пользователь не покупатель и не автор предложения */
    hideInfo(): boolean {
      return this.$core.currentPartner.isBuyer === false && this.offer.isMine === false;
    },
  },
});

</script>
